import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "b496bX0MT5L64xC2sgTTE1+", "LinkOut", undefined);

import { _decorator, Component, Node, SpriteFrame, Sprite } from 'cc';
import { E_PlatformType, NodeInWindow_Pos } from './common/EnumBase';
import { App } from './common/manager/App';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var LinkOut = (_dec = ccclass('LinkOut'), _dec2 = property(Sprite), _dec3 = property(Sprite), _dec4 = property(Node), _dec5 = property(Node), _dec6 = property([SpriteFrame]), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(LinkOut, _Component);

  function LinkOut() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "sp_1", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "sp_2", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "bg_1", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "bg_2", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "sfArr", _descriptor5, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_link", []);

    _defineProperty(_assertThisInitialized(_this), "_link1", 0);

    _defineProperty(_assertThisInitialized(_this), "_link2", 1);

    return _this;
  }

  var _proto = LinkOut.prototype;

  _proto.onLoad = function onLoad() {
    this._link = ["https://www.dob5.com?gameId=1040", "https://www.dob5.com?gameId=1046", "https://www.dob5.com?gameId=1053", "https://www.dob5.com?gameId=1055", "https://www.dob5.com?gameId=1056", "https://www.dob5.com?gameId=1057"];
    App.CommonAmn.recordInitPos(this.bg_1);
    App.CommonAmn.recordInitPos(this.bg_2);
    App.CommonAmn.recordExitPosByType(this.bg_1, NodeInWindow_Pos.Left);
    App.CommonAmn.recordExitPosByType(this.bg_2, NodeInWindow_Pos.Right);
  };

  _proto.start = function start() {
    // [3]
    App.GameCtrl.addBtnEvent(this.node, this.btn_event.bind(this));
  };

  _proto.enter = function enter() {
    this.node.active = true;

    if (App.AdCtrl.platformType == E_PlatformType.XiaoMi) {
      this.bg_1.active = false;
      this.bg_2.active = false;
      App.AdCtrl.showAd();
    } else {
      var tArr = App.ArrayHandler.create_int(6);
      var ind1 = App.NumHandler.round_int(tArr.length);
      var ind11 = tArr[ind1];
      tArr.splice(ind1, 1);
      var ind2 = App.NumHandler.round_int(tArr.length);
      var ind12 = tArr[ind2];
      this.sp_1.spriteFrame = this.sfArr[ind11];
      this.sp_2.spriteFrame = this.sfArr[ind12];
      this._link1 = ind1;
      this._link2 = ind2;
      App.CommonAmn.act_dir2Init_node(this.bg_1, NodeInWindow_Pos.Left, 0, 0.5, "backInOut");
      App.CommonAmn.act_dir2Init_node(this.bg_2, NodeInWindow_Pos.Right, 0, 0.5, "backInOut");
    }
  };

  _proto.exit = function exit() {
    var _this2 = this;

    if (App.AdCtrl.platformType == E_PlatformType.XiaoMi) {
      App.AdCtrl.closeAd();
    } else {
      App.CommonAmn.act_exit(this.bg_1, 0, 0.5, "backInOut");
      App.CommonAmn.act_exit(this.bg_2, 0, 0.5, "backInOut", function () {
        _this2.node.active = false;
      });
    }
  };

  _proto.btn_event = function btn_event(btn) {
    switch (btn.node.name) {
      case "n_link1":
        window.open(this._link[this._link1], "_self");
        break;

      case "n_link2":
        window.open(this._link[this._link2], "_self");
        break;
    }
  } // update (deltaTime: number) {
  //     // [4]
  // }
  ;

  return LinkOut;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "sp_1", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "sp_2", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "bg_1", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "bg_2", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "sfArr", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
})), _class2)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();